import { COMPANY } from "@/lib/site";

export const WhatsAppButton = () => {
  return (
    <a
      href={COMPANY.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe57] text-white pl-4 pr-5 py-3 shadow-lg shadow-black/20 transition-all duration-200 hover:scale-105 active:scale-100"
      style={{ borderRadius: "999px" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="w-6 h-6"
        aria-hidden="true"
      >
        <path d="M20.52 3.48A11.85 11.85 0 0 0 12.06 0C5.5 0 .17 5.33.17 11.9c0 2.1.55 4.15 1.6 5.96L0 24l6.32-1.65a11.86 11.86 0 0 0 5.74 1.47h.01c6.56 0 11.9-5.33 11.9-11.9 0-3.18-1.24-6.17-3.45-8.44ZM12.07 21.8h-.01a9.9 9.9 0 0 1-5.04-1.38l-.36-.22-3.74.98 1-3.64-.24-.38a9.9 9.9 0 1 1 18.39-5.27 9.93 9.93 0 0 1-10 9.91Zm5.43-7.41c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.66.15s-.76.97-.93 1.17c-.17.2-.34.22-.64.07-.3-.15-1.25-.46-2.39-1.47-.88-.78-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.18-.24-.57-.48-.5-.66-.51l-.56-.01c-.2 0-.5.07-.77.37s-1 .98-1 2.4 1.03 2.78 1.17 2.98c.15.2 2.03 3.1 4.92 4.34.69.3 1.22.48 1.64.62.69.22 1.32.19 1.81.12.55-.08 1.76-.72 2.01-1.41.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.34Z" />
      </svg>
      <span className="hidden md:inline text-sm font-bold tracking-wider uppercase">WhatsApp</span>
    </a>
  );
};
